module.exports = __webpack_public_path__ + "static/img/designGuide8.b6acf62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide8.png
// module id = iIFs
// module chunks = 2